// extracted by mini-css-extract-plugin
export default {"tableContainer":"weathertendencies_tableContainer__w3pDa","content":"weathertendencies_content__Scfff","icons":"weathertendencies_icons__hJNEy"};